import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { UpdateKentRebalancingScheduleRequest } from '@cast/types-kent';

import { getClusterRebalancingSchedulesQueryKey } from 'hooks/queries/kent/useGetClusterRebalancingSchedules';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

type RequestParams = Omit<
  UpdateKentRebalancingScheduleRequest,
  'organizationId'
>;

export const useUpdateRebalancingScheduleMutation = () => {
  const { currentOrganization } = useOrganizations();
  const organizationId = currentOrganization!.id;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      clusterId,
      id,
      updateRebalancingScheduleData,
    }: RequestParams) => {
      return apiClient.kent.updateRebalancingSchedule({
        organizationId,
        clusterId,
        id,
        updateRebalancingScheduleData,
      });
    },

    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: getClusterRebalancingSchedulesQueryKey(variables.clusterId),
      });
    },
    onError: (error) => {
      notify.error(
        `Failed to update rebalancing schedule: ${parseApiError(error)}`
      );
    },
  });
};
